"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./baseDropdown.scss");
const react_1 = require("react");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const dropdown_arrow_down_svg_1 = __importDefault(require("../../assets/images/icons/dropdown-arrow-down.svg"));
const dropdown_arrow_up_svg_1 = __importDefault(require("../../assets/images/icons/dropdown-arrow-up.svg"));
const BaseInput_1 = __importDefault(require("../baseInput/BaseInput"));
const react_2 = __importDefault(require("react"));
function BaseDropdown(props) {
    const wrapperRef = (0, react_1.useRef)(null);
    const [dropdownToggle, setDropdownToggle] = (0, react_1.useState)(false);
    const [activeIcon, setActiveIcon] = (0, react_1.useState)(dropdown_arrow_down_svg_1.default);
    (0, react_1.useEffect)(() => {
        if (dropdownToggle) {
            setActiveIcon(dropdown_arrow_up_svg_1.default);
        }
        else {
            setActiveIcon(dropdown_arrow_down_svg_1.default);
        }
    }, [dropdownToggle]);
    return (react_2.default.createElement(Dropdown_1.default, { id: `dropdown-basic-button${props.isMobile ? "-mobile" : ""}`, onSelect: (newValue) => props.onChangeAction(newValue), onToggle: (nextShow) => setDropdownToggle(nextShow), style: Object.assign({}, props.wrapperStyles) },
        react_2.default.createElement(Dropdown_1.default.Toggle, null,
            react_2.default.createElement("div", { className: "base-dropdown flex-column jc-sb", ref: wrapperRef },
                react_2.default.createElement(BaseInput_1.default, { className: "dropdown-input", width: props.width, height: props.height, placeholder: props.placeholder, value: props.value, onBlurAction: () => {
                        setActiveIcon(dropdown_arrow_down_svg_1.default);
                    }, onFocusAction: () => {
                        setActiveIcon(dropdown_arrow_up_svg_1.default);
                    }, styles: Object.assign(Object.assign({}, props.styles), { fontSize: "15px", fontStyle: "normal", fontWeight: 400, lineHeight: "normal" }) }),
                react_2.default.createElement("img", { src: activeIcon, alt: "Open Dropdown", height: 14, style: {
                        position: "absolute",
                        right: "15px",
                        top: `${(props.height - 14) / 2}px`,
                    } }),
                props.helperText ? (react_2.default.createElement("div", { className: "flex-row", style: { width: "100%" } },
                    react_2.default.createElement("span", { className: "helper-text" }, props.helperText))) : (react_2.default.createElement("div", { className: "sized-box", style: { height: "10px" } })))),
        react_2.default.createElement(Dropdown_1.default.Menu, null, props.dropdownOptions.map((option, i) => (react_2.default.createElement(Dropdown_1.default.Item, { eventKey: i, key: i }, option))))));
}
exports.default = BaseDropdown;
